module.exports = __webpack_public_path__ + "static/logo-f78505fd5cac0c114fa7bd5fd18901d6.png";